import template from './template.html.twig';

const { Component } = Shopware;

Component.register('neti-ior-settings-icon', {
    template,

    computed: {
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
    },
});
